export const user_routes = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/dashboard/Dashboard" } },
        meta: { requireNone: true, requireAuth: true, requireAdmin: false },
    },
    {
        path: '/map',
        name: 'map',
        component: () => import('@/layouts/Map'),
        props: { data: { page: "pages/map/Map" } },
        meta: { requireNone: true, requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/category',
    //     name: 'category',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/category/Category" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    {
        path: '/devices',
        name: 'devices',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/devices/Devices" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/register/Register" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/yeni_shexsler/:id?',
    //     name: 'add_person',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/Bazalar/persons/AddPerson" } },
    //     meta: { requireAuth: true, requireAdmin: false, selected_menu: 'persons', },
    // },
];
